import React from 'react';
import TimerRing from './TimerRing';

export default function GameScreen({ round, score, timeLeft, qIndex, question, locked, chosenIdx, difficulty, onAnswer, onExit }) {
  if (!question) return null;

  const diffColor = { easy: '#4caf50', medium: '#2196f3', hard: 'var(--red)', impossible: 'var(--gold)' }[difficulty];

  return (
    <div className="game-wrap fade-in">
      <div className="game-header">
        <div className="hud-item">
          <div className="hud-label">Round</div>
          <div className="hud-val" style={{ color: 'var(--red)' }}>{round} / 3</div>
        </div>
        <TimerRing timeLeft={timeLeft} total={15} />
        <div className="hud-item">
          <div className="hud-label">Score</div>
          <div className="hud-val" style={{ color: 'var(--gold)' }}>{score.toLocaleString()}</div>
        </div>
      </div>

      <div className="progress-bar-wrap">
        <div className="progress-bar-fill" style={{ width: `${(qIndex / 5) * 100}%` }} />
      </div>

      <div className="card q-card">
        <div className="q-meta">
          Question {qIndex + 1} of 5 &nbsp;·&nbsp;
          <span style={{ color: diffColor }}>{difficulty.toUpperCase()}</span>
        </div>
        <p className="q-text">{question.q}</p>
      </div>

      <div className="choices" key={`choices-${qIndex}`}>
        {question.choices.map((c, i) => {
          let cls = 'choice-btn';
          if (locked) {
            if (c === question.a) cls += ' correct';
            else if (i === chosenIdx) cls += ' wrong';
          }
          return (
            <button key={i} className={cls} disabled={locked} onClick={() => onAnswer(c, i)}>
              <span style={{ color: 'var(--muted)', marginRight: 6, fontFamily: "'Bebas Neue'" }}>
                {['A', 'B', 'C', 'D'][i]}.
              </span>
              {c}
            </button>
          );
        })}
      </div>

      <div style={{ textAlign: 'center', marginTop: 20 }}>
        <button className="exit-btn" onClick={onExit}>✕ Exit to Menu</button>
      </div>
    </div>
  );
}
